exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".config-list > .tabs-vertical > li {\n  padding: 0;\n}\n.config-list > .tabs-vertical > li > a {\n  padding: 18px 12px;\n}\n", ""]);

